/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import Slider from 'react-slick';
import { MD_BREAKPOINT } from '../../utils';
import { MediaProps } from './index';
import { CLOSED_PHOTO_INDEX, G17Lightbox } from '@components/lightbox';
import { useState } from 'react';


interface PhotosVideosProps {
  heading: string;
  mediaProducts: MediaProps[];
}

const PhotosVideos = (props: PhotosVideosProps) => {
  const { mediaProducts, heading } = props;
  const [photoIndex, setPhotoIndex] = useState(CLOSED_PHOTO_INDEX);

  const isMobile = window.innerWidth < MD_BREAKPOINT;

  const assets = mediaProducts.filter(media => media.photosVideos !== null);

  const photosVideosSettings = {
    dots: true,
    speed: 500,
    autoplaySpeed: 10000,
    autoplay: false,
    infinite: true,
    arrows: true,
    draggable: true,
    touchMove: true,
    swipeToSlide: true,
    cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    swipe: true,
    slidesToShow: isMobile ? 1 : (assets.length > 3 ? 3 : assets.length),
    pauseOnHover: true
  };

  const handleLightBox = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, idx: number) => {
    e.preventDefault();
    setPhotoIndex(idx);
  };

  const slides = assets.map((media) => ({
    src: `https://media.graphcms.com/compress/${media.photosVideos?.handle}`,
  }));

  return (
    <section className='photos-videos-container'>
      <h2 className='mt-5 mb-4 strong'>{heading}</h2>
      <div className='row-inner'>
        <Slider {...photosVideosSettings}>
          {assets.map((media, idx) => (
            <div key={idx} className='d-flex flex-column flex-lg-row media-slide-inner justify-content-center'>
              <div className='media-img-container'>
                <img
                  className={`${mediaProducts.length === 1 ? 'single-img' : 'media-img'}`}
                  src={`https://media.graphcms.com/compress/${media.photosVideos?.handle}`}
                  alt={`${media.photosVideos?.handle}`}
                  onClick={(e) => handleLightBox(e, idx)}
                />
              </div>
            </div>
          ))}
        </Slider>
        <G17Lightbox photoIndex={photoIndex} slides={slides} handleReset={() => setPhotoIndex(CLOSED_PHOTO_INDEX)} />
      </div>
    </section>
  );
}

export default PhotosVideos;
